import moment from "moment";
import { updateSession } from "../../../slices/sessions/updateSession/thunk";
import { terminateSession } from "../../../slices/sessions/terminateSession/thunk";
import { initiateSession } from "../../../slices/sessions/initiateSession/thunk";

export const goToIndex = (newIndex, animating, setActiveIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
};

export const grantData = (balanceData) => {
    return balanceData?.filter(item => !Object.keys(item).includes('currencyCode'));
}

export const sessionJsonAndApiCall = (updateRequestedUnit, updateUsedUnit, terminateUsedUnit, value, customerId, dispatch, setLoading, whichCall, setUpdateRequestedUnit, setUpdateUsedUnit, setTerminateUsedUnit) => {
    const jsonObj = JSON.stringify({
        "eventType": whichCall === "Update" ? "Updated" : "Ended",
        "timestamp": moment().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        "sessionId": value?.sessionId,
        "subscriptionId": value?.subscriptionId,
        "seqno": value?.seqno[(value?.seqno).length - 1] + 1,
        ...(whichCall === "Update" && { "requestedUnit": parseFloat(updateRequestedUnit) }),
        "usedUnit": parseFloat(whichCall === "Update" ? updateUsedUnit : terminateUsedUnit),
        "uom": value?.uom,
        "usageEventType": value?.usageEventType,
        "triggerReason": ""
    })
    if (whichCall === "Update") {
        dispatch(updateSession(jsonObj, setLoading, customerId, value?.subscriptionId, setUpdateRequestedUnit))
    }
    else if (whichCall === "Terminate") {
        dispatch(terminateSession(jsonObj, setLoading, customerId, value?.subscriptionId))
    }

    setUpdateRequestedUnit([])
    setUpdateUsedUnit("")
    setTerminateUsedUnit("")

}

export const optionsForSubscriptionId = (commonID) => {
    const seen = new Set();
    const optionsForSelect = [];

    commonID?.forEach((common) => {
        const id = common?.subscriptionId;
        if (id && !seen.has(id)) {
            seen.add(id);
            optionsForSelect.push({ value: id, label: id });
        }
    });

    return optionsForSelect;
};

export const eventTypeOptions = (eventType) => {
    const eventOptions = eventType?.map((item) => {
        return {
            label: item.eventType,
            value: item.eventType,
        };
    }) || [];
    return eventOptions;
}

export const uomOptions = (uom, usageEventType) => {
    if (!uom || !usageEventType) return [];

    const matchingUOM = uom.find((item) => item.eventType === usageEventType);

    if (matchingUOM) {
        const UOMOptions = matchingUOM.uomName?.map((uom) => ({
            label: uom,
            value: uom,
        })) || [];

        return UOMOptions;
    }

    return [];
};


export const initiateSessionApiCall = (value, dispatch, setLoading, navigate, customerId, fullName, setShowForm, isView, resetForm = null,setSessionAction, toggle) => {
    // Check if current pathname includes 'simulate'
    const isSimulatePage = window.location.pathname.includes('simulate');
    
    // Filter attributes to only include those with both name and value
    const validAttributes = value?.attributes?.filter(attr => {
        const attributeName = attr.name?.value || attr.name;
        const attributeValue = attr.value;
        return attributeName && attributeValue && attributeName.trim() !== '' && attributeValue.trim() !== '';
    }).map(attr => {
        const attributeName = attr.name?.value || attr.name;
        let attributeValue = attr.value;
        const valueType = attr.name?.valueType || attr.valueType;
        // Convert value based on valueType
        switch (valueType) {
            case "integer":
                attributeValue = attributeValue === "" ? "" : parseInt(attributeValue, 10);
                break;
            case "float64":
                attributeValue = attributeValue === "" ? "" : parseFloat(attributeValue);
                break;
            case "bool":
                case "list":
                case "string":
            default:
                // keep as string
                break;
        }
        return {
            "attributeName": attributeName,
            "attributeValue": attributeValue
        };
    });

    const payload = {
        "eventType": "Started",
        "timestamp": moment(value?.sessionTime).format('YYYY-MM-DDTHH:mm:ss[Z]'),
        "sessionId": `TEST-SESSION-${value.sessionId}`,
        "subscriptionId": value?.subscriptionId?.value,
        "seqno": 1,
        ...(value?.requestedUnits ? { requestedServiceUnit: parseFloat(value.requestedUnits) } : {}),
        "uom": value?.uom?.value,
        "usageEventType": value?.usageEventType?.value
    };

    // Only add attributes if there are valid ones
    if (validAttributes && validAttributes.length > 0) {
        payload.attributes = validAttributes;
    }
const getEmptyFormValues = () => {
        return {
            subscriptionId: '',
            usageEventType: '',
            sessionId: '',
            sessionTime: null,
            requestedUnits: '',
            usedUnits: '',
            uom: '',
            attributes: [{ name: '', value: '' }]
        };
    };
    
    const jsonObj = JSON.stringify(payload);
    dispatch(initiateSession(jsonObj, setLoading, navigate, customerId, fullName, setShowForm, isView, isSimulatePage, resetForm,getEmptyFormValues,setSessionAction,toggle));
}
